module.exports = __webpack_public_path__ + "eddc5abb8686fffbc9f9fa841727baff.svg";